/* Pastry Pets in site search (Oct 22 2026). Reads the Typesense alias pastry_pets with the search-only key from #VGH.
   1) Header search box: a short "Pastry Pets" suggestion list under the input (up to 4 for dog questions, 1 otherwise).
   2) /search results page: a "From Pastry Pets" block, at the top for dog questions, below the shop results otherwise.
   No tracking, no cookies. Fails silently: search keeps working without it. */
(function () {
  var root = document.getElementById('VGH');
  if (!root || !root.dataset.ppHost || !root.dataset.ppKey || !window.fetch) return;
  var HOST = root.dataset.ppHost, KEY = root.dataset.ppKey;
  var DOG = /\b(dog|dogs|doggy|puppy|puppies|pup|pups|pet|pets|canine|vet|vets|veterinarian|breed|breeds|retriever|terrier|poodle|labrador|lab|shepherd|bulldog|beagle|dachshund|corgi|husky|boxer|rottweiler|chihuahua|shih|doodle|dane|yorkie|spaniel|pointer|schnauzer|pastry pets)\b/i;
  var LABEL = { breed: 'Dog breed', ingredient: 'Can dogs eat it?', guide: 'Guide', page: 'Pastry Pets' };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function search(q, dog, n) {
    var p = new URLSearchParams({ q: q, query_by: dog ? 'title,keywords,summary' : 'title,keywords', query_by_weights: dog ? '4,3,1' : '4,3',
      per_page: String(n), num_typos: '1', drop_tokens_threshold: dog ? '1' : '0', prioritize_exact_match: 'true',
      sort_by: '_text_match:desc,rank:desc', include_fields: 'title,url,type,verdict' });
    return fetch('https://' + HOST + '/collections/pastry_pets/documents/search?' + p, { headers: { 'X-TYPESENSE-API-KEY': KEY } })
      .then(function (r) { return r.ok ? r.json() : { hits: [] }; })
      .then(function (j) { return (j.hits || []).map(function (h) { return h.document; }); })
      .catch(function () { return []; });
  }
  function item(d) {
    var tag = d.verdict ? '<span class="pp-ss-v pp-ss-v--' + esc(d.verdict.split(':')[0].split(' ')[0].toLowerCase()) + '">' + esc(d.verdict) + '</span>' : '<span class="pp-ss-t">' + esc(LABEL[d.type] || '') + '</span>';
    return '<li><a href="' + esc(d.url) + '"><b>' + esc(d.title) + '</b>' + tag + '</a></li>';
  }

  var css = document.createElement('style');
  css.textContent = '.pp-ss{max-width:760px;margin:0 auto;padding:0 24px 18px}.pp-ss h2,.pp-ss p.pp-ss-h{font-size:12px;letter-spacing:.08em;text-transform:uppercase;font-weight:700;color:#7a5a3f;margin:0 0 8px}' +
    '.pp-ss ul{list-style:none;margin:0;padding:0;display:grid;gap:6px}.pp-ss a{display:flex;flex-wrap:wrap;gap:4px 10px;align-items:center;justify-content:space-between;padding:10px 12px;border:1px solid #e6dccd;background:#fffdf9;color:#2f2118;text-decoration:none;border-radius:8px}' +
    '.pp-ss a:hover,.pp-ss a:focus-visible{border-color:#b8873b;outline:none}.pp-ss b{font-weight:700}.pp-ss-t,.pp-ss-v{font-size:12px;font-weight:700;padding:2px 8px;border-radius:999px;background:#f3ebe0;color:#6b4b31}' +
    '.pp-ss-v--toxic{background:#fde2df;color:#8f1d12}.pp-ss-v--keep{background:#fdebd9;color:#8a4210}.pp-ss-v--use{background:#fff3cf;color:#6b5100}.pp-ss-v--small{background:#e3f1e3;color:#245c2a}' +
    '.pp-ss-more{font-size:13px;margin:8px 0 0}.pp-ss-more a{display:inline;border:0;padding:0;background:none;text-decoration:underline}' +
    '.pp-ss--page{max-width:74.1rem;padding:0 1.5rem;margin:0 auto 3rem}.pp-ss--page ul{grid-template-columns:repeat(auto-fill,minmax(260px,1fr))}';
  document.head.appendChild(css);

  /* 1) header suggestions */
  var input = root.querySelector('#VGH-q'), box = root.querySelector('#VGH-search');
  if (input && box) {
    var list = document.createElement('div');
    list.className = 'pp-ss'; list.hidden = true; list.setAttribute('aria-live', 'polite');
    box.appendChild(list);
    var timer, last = '';
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 3) { list.hidden = true; last = ''; return; }
      timer = setTimeout(function () {
        if (q === last) return;
        last = q;
        var dog = DOG.test(q);
        search(q, dog, dog ? 4 : 1).then(function (docs) {
          if (input.value.trim() !== q) return;
          if (!docs.length) { list.hidden = true; return; }
          list.innerHTML = '<p class="pp-ss-h">Pastry Pets · for dog owners</p><ul>' + docs.map(item).join('') + '</ul>';
          list.hidden = false;
        });
      }, 220);
    });
  }

  /* 2) search results page */
  var page = document.querySelector('.template-search');
  if (page && location.pathname.indexOf('/search') === 0) {
    var q = (new URLSearchParams(location.search).get('q') || '').trim();
    if (q.length < 3) return;
    var dog = DOG.test(q);
    search(q, dog, dog ? 6 : 3).then(function (docs) {
      if (!docs.length) return;
      var top = dog || docs[0].type === 'breed' || page.classList.contains('template-search--empty');
      var sec = document.createElement('section');
      sec.className = 'pp-ss pp-ss--page';
      sec.setAttribute('aria-label', 'Results from Pastry Pets');
      sec.innerHTML = '<h2>From Pastry Pets: dogs and baking safety</h2><ul>' + docs.map(item).join('') + '</ul>' +
        '<p class="pp-ss-more"><a href="/pages/can-dogs-eat">Check another ingredient</a> · <a href="/pages/dog-breeds">Dog breeds</a> · Dog ate something? Call your vet or ASPCA Poison Control (888) 426-4435.</p>';
      var head = page.querySelector('.template-search__header');
      if (top && head) head.insertAdjacentElement('afterend', sec); else page.appendChild(sec);
    });
  }
})();
